import React, { useState, useEffect, useMemo } from 'react'
import { connect } from "react-redux"
import TopBarNav from '../common/TopBarNav'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import { useHistory } from 'react-router-dom'
import DataTable from 'react-data-table-component'
import * as maintenanceActions from '../../actions/maintenance/MaintenanceActions'
import { downloadCSVOtherStatus, getFilteredTableTitle, getTableColumns } from "../common/Utils"
import { MaintenanceStyles } from './MaintenanceStyles'
import TableFilterComponent from '../common/TableFilterComponentAlter'
import { bindActionCreators } from 'redux'
import * as navigationActions from '../../actions/common/NavigationActions'
import BreadcrumbsHistory from '../common/BreadcrumbsHistory'
import { Backdrop, CircularProgress } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import Constants from '../common/Constants.json'

const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de', selectAllRowsItem: true, selectAllRowsItemText: 'Todos' }

const MaintenanceListByStatus = ({ classes, ...props }) => {
    const history = useHistory()
    const [filterText, setFilterText] = useState('')
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false)
    const [startDate, setStartDate] = useState()
    const [endDate, setEndDate] = useState()
    const [searchButton, setSearchButton] = useState(0)
    const { match: { params } } = props
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const { t } = useTranslation()

    const getExcelConfiguration = (status) => {
        switch (status) {
            case '0':
                return excelConfiguration
            case '3':
                return excelConfiguration
            case '20':
                return excelConfiguration
            case '6':
                return excelConfiguration
            case '9':
                return excelConfigurationStatusRejected
            case '12':
                return excelConfigurationStatusPaymentProcess 
            case '15':
                return excelConfigurationStatusPayed
            default:
                return
        }
    }

    
    const excelConfigurationStatusPayed = [
        {
            selector: 'cAndR',
            label: 'Autorización'
        },
        {
            selector: 'vin',
            label: 'VIN'
        },
        {
            selector: 'creationDate',
            label: 'Fecha de creación'
        },
        {
            selector: 'sucursal',
            label: 'Sucursal'
        },
        {
            selector: 'invoiceStatus',
            label: 'Estatus de Factura'
        },
        {
            selector: 'invoiceAmount',
            label: 'Monto de factura'
        }
    ]

    const excelConfigurationStatusPaymentProcess = [
        {
            selector: 'cAndR',
            label: 'Autorización'
        },
        {
            selector: 'vin',
            label: 'VIN'
        },
        {
            selector: 'creationDate',
            label: 'Fecha de creación'
        },
        {
            selector: 'sucursal',
            label: 'Sucursal'
        },
        {
            selector: 'invoiceStatus',
            label: 'Estatus de Factura'
        },
        {
            selector: 'invoiceAmount',
            label: 'Monto de factura'
        }
    ]

    const excelConfigurationStatusRejected = [
        {
            selector: 'cAndR',
            label: 'Autorización'
        },
        {
            selector: 'vin',
            label: 'VIN'
        },
        {
            selector: 'creationDate',
            label: 'Fecha de creación'
        },
        {
            selector: 'sucursal',
            label: 'Sucursal'
        },
        {
            selector: 'invoiceStatus',
            label: 'Estatus de la orden'
        },
        {
            selector: 'invoiceAmount',
            label: 'Monto de la orden'
        }
    ]

    const excelConfiguration = [
        {
            selector: 'cAndR',
            label: 'Autorización'
        },
        {
            selector: 'vin',
            label: 'VIN'
        },
        {
            selector: 'creationDate',
            label: 'Fecha de creación'
        },
        {
            selector: 'sucursal',
            label: 'Sucursal'
        },
        {
            selector: 'invoiceStatus',
            label: 'Estatus de Factura'
        },
        {
            selector: 'invoiceAmount',
            label: 'Monto de factura'
        }
    ]

    useEffect(() => {
        handleOpenBackdrop()
        const newRoute = {
            path: '/maintenance/listByStatus',
            linkLegend: 'Lista',
            urlParams: [{ key: 'status', value: params.status }, { key: 'branchOfficeId', value: params.branchOfficeId }]
        }
        props.navigationActions.add_route(newRoute)
        props.actions.fecth_oc_by_status(props.userLanguage, props.userToken, params.branchOfficeId, params.status, startDate, endDate, filterText, onError, onSuccess)
        return () => {
            props.cleanUserProfile()
        }
    }, [filterText, searchButton]) // eslint-disable-line react-hooks/exhaustive-deps

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }
    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }
    const onSuccess = () => {
        handleCloseBackdrop()
    }

    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    break
                case 403:
                    history.push('/forbidden')
                    break
                case 500:
                    console.log(err.response.data)
                    break
                default:
                    break
            }
        }
    }

    const subHeaderComponentMemo = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText('');
            }
        }

        const handleStartDateChange = (e) => {
            if (e != null)
                setStartDate(e.format('YYYY-MM-DD'))
            else
                setStartDate(null)
        }

        const handleEndDateChange = (e) => {
            if (e != null)
                setEndDate(e.format('YYYY-MM-DD'))
            else
                setEndDate(null)
        }

        return <TableFilterComponent
            onFilter={e => setFilterText(e.target.value)}
            onClear={handleClear} filterText={filterText}
            onStartDateChange={handleStartDateChange}
            onEndDateChange={handleEndDateChange}
            onClickSearch={() => setSearchButton(searchButton + 1)}
            onExport={() => downloadCSVOtherStatus(props.listByStatus, getExcelConfiguration(params.status),params.status)}
            styles={classes.searchAlign}
            isSubHeader={params.status === '6' ? true : false}
            textSubHeader={Constants.LegendsForAP.paymentStatus}
        />;
    }, [filterText, resetPaginationToggle, searchButton, props]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div>
            <TopBarNav />
            <br />
            <BreadcrumbsHistory />
            <br />
            <Container maxWidth="lg" className={classes.root}>
                <Backdrop className={classes.backdrop} open={openBackdrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Grid container item xs={12} spacing={3} >
                    <Grid item xs={12} className={classes.dashboardAlign}>
                    </Grid>
                </Grid>
                <Grid>
                    <DataTable
                        title={getFilteredTableTitle("Maintenance", params.status)}
                        columns={getTableColumns("Maintenance", params.status)}
                        data={props.listByStatus}
                        defaultSortField={(params.status === '9' || params.status === '12' || params.status === '15'  ) ? 'creationDate' : 'cAndR'}
                        defaultSortAsc={(params.status === '9' || params.status === '12' || params.status === '15'  ) ? false: true}
                        highlightOnHover
                        dense
                        pointerOnHover
                        pagination
                        paginationComponentOptions={paginationOptions}
                        subHeader
                        subHeaderComponent={subHeaderComponentMemo}
                        noDataComponent={<p className={classes.marginNoData}>{t('commonMessages.noData')}</p>}
                    />
                </Grid>
            </Container>
        </div>
    )
}

const mapStateToProps = state => ({
    userProfile: state.UserProfileReducer.list,
    listByStatus: state.MaintenanceReducer.listOrders,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
        cleanUserProfile: () => dispatch({ type: 'CLEAN_USER_PROFILE' }),
        actions: bindActionCreators(maintenanceActions, dispatch),
        navigationActions: bindActionCreators(navigationActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(MaintenanceStyles)(MaintenanceListByStatus))